
/**
 * @mixin Render proxy for a single overlay component.
 */
export default {
    props: {
        hosted: Object
    },

    watch: {
        hosted: {
            handler(hosted) {
                hosted.proxy_ = this;
                this.$root = hosted.$root;
            },
            immediate: true
        }
    },

    beforeCreate() {
        this.isProxy_ = true;
    },

    mounted() {
        const hosted = this.hosted;
        if (hosted.mounted) {
            return hosted.mounted.forEach(fn => { fn.call(hosted) });
        }
    },

    render(h) {
        const hosted = this.hosted;
        void hosted.key;
        if (hosted.render) {
            return hosted.render(h);
        }
    },

    beforeDestroy() {
        if (this.hosted) {
            this.hosted.proxy_ = null;
        }
    }
}
